import { motion } from "framer-motion";
import { useLanguage } from "../lib/LanguageContext";

export default function OrderFlow() {
  const { t } = useLanguage();
  return (
    <section data-testid="order-section" className="bg-paper py-28 md:py-36">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid md:grid-cols-12 gap-6 items-end mb-14">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-px bg-warmbrown" />
              <span className="eyebrow">{t.order.eyebrow}</span>
            </div>
            <h2 className="font-serif text-3xl md:text-5xl leading-[1.05] tracking-tight text-ink">{t.order.title}</h2>
          </div>
          <div className="md:col-span-5">
            <p className="font-body italic text-ink-soft">{t.order.note}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-0 border-t border-dustyrose/40">
          {t.order.steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, delay: i * 0.07 }}
              className="border-b sm:border-b-0 sm:border-r border-dustyrose/30 last:border-r-0 px-2 py-8 md:p-8"
              data-testid={`order-step-${s.n}`}
            >
              <p className="font-serif italic text-dustyrose-deep text-xl">{s.n}</p>
              <p className="font-serif text-lg md:text-xl text-ink mt-4 leading-snug">{s.t}</p>
              <p className="font-body text-sm text-ink-soft mt-3 leading-relaxed">{s.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
